import { NavLink, useParams, useSearchParams } from 'react-router-dom'

import i18n from './i18n'
import css from './index.module.css'

import type { Engine } from '#/App'

import { Config } from '#/global/helper/Config'

interface Props {
    views: Record<Engine, number>
}

export const TabNavigation = ({ views }: Props) => {
    const [searchParameters] = useSearchParams()
    let { branchTitle } = useParams()
    const query = searchParameters.get('query')

    branchTitle = branchTitle ? `/${branchTitle}` : ''

    return (
        <div className={css.nav} data-name="r-a-search r-tab-navigation">
            {views.productsEshop > 0 && (
                <NavItem badge={views.productsEshop} id="eshop" to={`${branchTitle}/search/eshop?query=${query}`} />
            )}
            {views.productsRental > 0 && (
                <NavItem badge={views.productsRental} id="rental" to={`${branchTitle}/search/rental?query=${query}`} />
            )}
            {(views.categoriesEshop > 0 || views.categoriesRental > 0) && (
                <NavItem badge={views.categoriesEshop + views.categoriesRental} id="category" to={`${branchTitle}/search/category?query=${query}`} />
            )}
            {views.articles > 0 && (
                <NavItem badge={views.articles} id="article" to={`${branchTitle}/search/article?query=${query}`} />
            )}
            {views.productsSeason > 0 && (
                <NavItem badge={views.productsSeason} id="season" to={`${branchTitle}/search/season?query=${query}`} />
            )}
        </div>
    )
}

interface NavItemProps {
    badge: number
    id: 'eshop' | 'rental' | 'category' | 'article' | 'season'
    to: string
}

const NavItem = ({ badge, id, to }: NavItemProps) => (
    // https://reactrouter.com/en/main/components/nav-link#classname
    <NavLink className={({ isActive }) => css.navItem + (isActive ? ` ${css.active}` : '')} to={to}>
        <span>{i18n[Config.getLang()][id]}</span>
        <span>
            (
            {badge > 240 ? '240+' : badge}
            )
        </span>
    </NavLink>
)
